import { usePage } from "@inertiajs/react";

import type { ProgramProps, SharedProps } from "@/types";

/** Program identity shared on every page (name, currency nouns, help channel, version). */
export function useProgram(): ProgramProps {
  return usePage<SharedProps>().props.program;
}
